module.exports = __webpack_public_path__ + "static/product-no-limit@2x-1fd6a4831da069af91f391f5adbbef1c.png";